import { render, staticRenderFns } from "./FlagsVerifications.vue?vue&type=template&id=47f3b626&scoped=true&"
import script from "./FlagsVerifications.vue?vue&type=script&lang=js&"
export * from "./FlagsVerifications.vue?vue&type=script&lang=js&"
import style0 from "./FlagsVerifications.vue?vue&type=style&index=0&id=47f3b626&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47f3b626",
  null
  
)

export default component.exports